export default __webpack_public_path__ + "static/media/yt.5796a8dd.svg";